import { toast } from "react-toastify";

//deve ter um ToastContainer implementado na root da aplicação
export const Alerta = (type = "default", message) => {
  switch (type.toLowerCase()) {
    case "sucesso":
      toast.success(message);
      break;
    case "alerta":
      toast.warn(message);
      break;
    case "erro":
      toast.error(message);
      break;
    case "info":
      toast.info(message);
      break;
    default:
      toast.info(message);
  }
};
